export default __webpack_public_path__ + "static/media/1c.7e065822.png";